define([
    'common/ui/view/svg/index'
], function(
    SVGView
    ) {
    var SVGTextpathView = SVGView.extend({
        tagName: 'g',

        initialize: function(params) {
            SVGTextpathView.__super__.initialize.call(this, params);
            this.id = params.id;
            this.path = params.path;
            this.offset = params.offset;
            this.classes = params.classes;
        },

        onRender: function() {
            this.$el.append('path')
                .attr('d', this.path)
                .attr('id', this.id);

            this.$text = this.$el.append('text')
                .style('letter-spacing', 2);

            this.$textpath = this.$text
                .append('textPath')
                .classed('svg-textpath', true)
                .attr('xlink:href', '#' + this.id)
                .attr('startOffset', this.offset);

            return this;
        },

        text: function(text) {
            this.$textpath.text(text);
        }
    });

    return SVGTextpathView;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/text/path.js